import {useTranslation} from 'react-i18next';
import _ from 'lodash';
import {ControlDependency} from '../../../controls/agyle/triageControls';
import React, {useState} from 'react';
import {PATIENT_CONTEXT_TYPE} from '../../../util/patientContextUtil';
import MiniFormDialog from '../../../components/modal/miniFormDialog';

const DependencyMiniForm = (props) => {
    const {t} = useTranslation();

    const [formState, setFormState] = useState(props?.patient?.triage || null);

    return (
        <MiniFormDialog
            onClose={props.onClose}
            open={props.open}
            title={t(`${props.patient?.triage?.dependency ? 'Edit' : 'Add'} Dependency`)}
            closeButtonOnHeader
            onSave={() => {
                props.onChange([{name: 'triage', value: formState}]);
                props.onClose();
            }}
            formOptions={props._formOptions}
        >
            <ControlDependency
                label={t('Dependency')}
                value={formState?.dependency}
                disabled={props.disableSave || props.patientType === PATIENT_CONTEXT_TYPE.EDAU}
                onChange={(value) => {
                    let clone = _.cloneDeep(props.patient?.triage);
                    if (!clone) {
                        clone = {};
                    }
                    clone.dependency = value;
                    setFormState(clone);
                }}
                size="large"
                noBorder={false}
                withNewBackground
            />
        </MiniFormDialog>
    );
};

export default DependencyMiniForm;